import { render, staticRenderFns } from "./onebox-public.vue?vue&type=template&id=56014b97&"
import script from "./onebox-public.vue?vue&type=script&lang=js&"
export * from "./onebox-public.vue?vue&type=script&lang=js&"
import style0 from "./onebox-public.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports